import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import { ArrowForwardIos } from '@material-ui/icons';
import NextLink from '../NextLink';
import { colors, fontSize } from '../../constants/styleConstants';

const useStyles = makeStyles(() => ({
  linkBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 4,
    paddingRight: 5,
  },
  link: {
    display: 'flex',
    alignItems: 'center',
    paddingRight: 10,
  },
  linkText: {
    lineHeight: 1.2,
  },
  icon: {
    marginRight: 6,
  },
  arrowIcon: {
    fontSize: 12,
    '&:hover': {
      color: colors.blue,
    },
  },
}));

const LinkText = styled.span`
  font-size: ${props => {
    switch (props.size) {
      case 'medium':
        return fontSize.medium;
      case 'large':
        return fontSize.large;
      default:
        return fontSize.regularTitle;
    }
  }}px;
  color: ${props => {
    return colors[props.color];
  }};
  font-weight: ${props => {
    switch (props.weight) {
      case 'bold':
        return 'bold';
      default:
        return 'normal';
    }
  }};
  &:hover: {
    color: ${props => {
      switch (props.color) {
        case 'white':
          return colors.white;
        case 'blue':
          return colors.linkHover;
        default:
          return colors.linkHover;
      }
    }};
  }
`;

const GoToLink = ({ linkText, linkProps, size, color, icon, weight }) => {
  const classes = useStyles();

  return (
    <NextLink className={classes.linkBox} {...linkProps}>
      <div className={classes.link}>
        {icon && <span className={classes.icon}>{icon}</span>}
        <LinkText size={size} color={color} weight={weight} className={classes.linkText}>
          {linkText}
        </LinkText>
      </div>
      <ArrowForwardIos style={{ fontSize: 12, color: colors[color] }} />
    </NextLink>
  );
};

GoToLink.propTypes = {
  linkProps: PropTypes.oneOfType([PropTypes.shape({ ...NextLink.propTypes }), PropTypes.func]),
  linkText: PropTypes.string,
  size: PropTypes.string,
  color: PropTypes.string,
  weight: PropTypes.string,
  icon: PropTypes.node,
};

export default GoToLink;
